var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7.63 14.57a.64.64 0 00.91 0l8.22-8.22a.64.64 0 10-.91-.92L8.08 13.2 4.15 9.27a.65.65 0 00-.9.9l4.38 4.4z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }